import { forwardRef } from 'react';
import { Avatar, AvatarLetter, Tooltip } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { FadeOutContainer, FadeOutSpacer, IconContainer, StyledOverflowTypography } from '../components';
import { useSidebarMenu } from '../useSidebarMenu';
import { SidebarMenuUserContainer, TextContainer } from './styled';
export const SidebarMenuUser = forwardRef((props, ref) => {
    const { userName, companyName, minimizedTooltip } = props;
    const { minimized } = useSidebarMenu();
    return (<Tooltip disabled={!minimized} title={minimizedTooltip} side="right">
      <SidebarMenuUserContainer ref={ref} $active={false} $minimized={minimized}>
        <IconContainer>
          <Avatar size="md">
            <AvatarLetter>{userName[0]}</AvatarLetter>
          </Avatar>
        </IconContainer>
        <FadeOutContainer $minimized={minimized}>
          <FadeOutSpacer>
            <TextContainer>
              <StyledOverflowTypography $lineHeight="neutralized" $appearance="300" $fontWeight="semibold" $fontSize="small">
                {userName}
              </StyledOverflowTypography>
              <StyledOverflowTypography $lineHeight="neutralized" $appearance="200" $fontWeight="regular" $fontSize="tiny">
                {companyName}
              </StyledOverflowTypography>
            </TextContainer>
            <IconContainer>
              <Falcon icon="chevron-right"/>
            </IconContainer>
          </FadeOutSpacer>
        </FadeOutContainer>
      </SidebarMenuUserContainer>
    </Tooltip>);
});
